/* eslint-disable */
import React, { Component } from "react";
import { FormControl, FormGroup, FormLabel, Checkbox, FormControlLabel, TextField } from "@material-ui/core";
import { indexOf, isEqual, uniq, some } from "lodash";
import "../../assets/css/dashboard/upload.scss";
import M from "materialize-css";
import Alert from "react-s-alert";
const addLabelModalId = "addLabels";

export const AddLabelModalInstance = () => {
  var elem = document.getElementById(addLabelModalId);
  return M.Modal.getInstance(elem);
};

class AddLabels extends Component {
  state = { labelName: "", createNew: false, isLoading: false, selectedLabels: [], allLabels: [], searchHint: "" };
  componentDidMount() {
    const options = {
      onOpenStart: () => {
        const { allLabels } = this.props;
        this.setState({ labelName: "", documentLabel: "", isLoading: false, createNew: false, searchHint: "", allLabels });
      },
      inDuration: 250,
      outDuration: 250,
      opacity: 0.5,
      dismissible: false,
      startingTop: "10%",
      endingTop: "10%",
    };
    var elem = document.getElementById(addLabelModalId);
    M.Modal.init(elem, options);
  }

  componentDidUpdate(oldProps) {
    let newProps = this.props;
    if (!isEqual(newProps.selectedLabels, oldProps.selectedLabels)) {
      this.setState({ selectedLabels: newProps.selectedLabels });
    }
    if (!isEqual(newProps.allLabels, oldProps.allLabels)) {
      this.setState({ allLabels: newProps.allLabels });
    }
  }

  addLabel = (e) => {
    const { labelName, createNew, allLabels } = this.state;
    this.setState({ isLoading: true });
    const alreadyExist = some(allLabels, (label) => label.toLowerCase() === labelName.toLowerCase());
    if (!labelName) {
      this.setState({ isLoading: false });
      Alert.error("Enter label name");
    } else if (alreadyExist) {
      this.setState({ isLoading: false });
      Alert.error(`Label '${labelName} already exists.`);
    } else {
      this.props.addLabel([this.state.labelName], createNew);
    }
  };

  applyLabels = () => {
    const { selectedLabels } = this.state;
    this.props.addLabel(selectedLabels);
  };

  onChangeValue = (value) => {
    this.setState({ labelName: value });
    // if (value !== "") {
    //   this.setState({ errorMessage: "" });
    // }
  };

  toggleLabel = (label) => {
    const { selectedLabels } = this.state;
    if (selectedLabels.some((name) => label === name)) {
      this.setState((state) => ({
        selectedLabels: state.selectedLabels.filter((name) => name !== label),
      }));
    } else {
      this.setState((state) => ({
        selectedLabels: uniq([...state.selectedLabels, label]),
      }));
    }
  };

  searchLabels = (searchHint) => {
    const { allLabels } = this.props;
    if (searchHint) {
      this.setState({
        allLabels: allLabels.filter((name) => name.toLowerCase().startsWith(searchHint.toLowerCase())),
        searchHint,
      });
    } else {
      this.setState({ allLabels, searchHint });
    }
  };

  createNew = () => {
    this.setState((state) => ({
      labelName: state.searchHint,
      createNew: true,
    }));
  };

  render() {
    const { selectedLabels: documentLabels } = this.props;
    const { isLoading, allLabels, selectedLabels, createNew, searchHint } = this.state;
    return (
      <div id="addLabels" className="modal model-newfolder">
        <div className="modal-content">
          <button type="button" className="modal-close" data-dismiss="modal">
            &times;
          </button>
          {createNew ? (
            <div className="col s12 lang">
              <h4>Add New Label</h4>
              <div className="row">
                <div className="input-field col s12">
                  <input className="input_text" type="text" value={this.state.labelName} onChange={(e) => this.onChangeValue(e.target.value)} />
                  <label for="Label Name" class="">Label Name</label>
                </div>
                <div className="col s12">
                  <button className="waves-effect waves-light btn btn-round cancel-btn create-btn" onClick={() => this.setState({ createNew: false })}>
                    Cancel
                  </button>
                  <button className="waves-effect waves-light btn btn-round create-btn" disabled={isLoading} onClick={this.addLabel}>
                    Add
                  </button>
                </div>
              </div>
            </div>
          ) : (
              <FormControl component="fieldset" className="new-labels">
                <FormLabel component="legend">Choose Label</FormLabel>
                <TextField id="outlined-basic" label="Search" variant="outlined" value={searchHint} onChange={(event) => this.searchLabels(event.target.value)} />
                <FormGroup aria-label="position" row>
                  {!!allLabels.length &&
                    allLabels.map((label, index) => (
                      <FormControlLabel
                        key={index}
                        value={label}
                        control={<Checkbox color="primary" />}
                        label={label}
                        labelPlacement="end"
                        checked={indexOf(selectedLabels, label) !== -1}
                        onChange={(event) => this.toggleLabel(label)}
                      />
                    ))}
                </FormGroup>
                <hr />
                {!isEqual(documentLabels, selectedLabels) && (
                  <button className="waves-effect waves-light btn btn-round create-btn  apply-btn" onClick={this.applyLabels}>
                    Apply
                  </button>
                )}
                <button className="waves-effect waves-light btn btn-round create-btn" onClick={this.createNew}>
                  Create New
              </button>
              </FormControl>
            )}
        </div>
      </div>
    );
  }
}

export default AddLabels;
